import Slider from '../../../framework/slider';

type resetAnimationType = () => void;
type startAnimationType = (fps:number) => void;
type animateCarouselType = () => void;
type initializeLoryType = () => void;
type addSubscriptionsType = () => void;
export default class TestimonialCarousel extends Slider {
    private frameId: number;
    private fpsInterval: number;
    private timeThen: number;
    private timeNow: number;
    private timeElapsed: number;
    

	constructor(element:HTMLElement) {
		const isExperienceEditor:boolean = document.body.classList.contains('isSitecoreEditor');
		super({
			element,
			dotContainer: '.v2-slider__dots',
			slideContainer: '.v2-slider',
			createBullets: true,
			sliderOpts: {
				infinite: isExperienceEditor ? false : 1
			}
		});
		this.initializeLory();
		this.publishBreakpointOnResize();
		this.addSubscriptions();
		const carouselDots:HTMLElement = this.element.querySelector('ul.v2-slider__dots');
		this.addEventListener(carouselDots, 'click', evt => {
			if (evt.target.closest('li')) {
				this.resetAnimation();
			}
		});
		this.element.addEventListener('after.lory.slide', () => {
			this.resetAnimation();
		});
		this.startAnimation(0.14); // value 0.14 is used for taking 7000 as fpsInterval.
	}

	resetAnimation: resetAnimationType = ():void => {
		window.cancelAnimationFrame(this.frameId);
		this.startAnimation(0.14);
	}

	startAnimation: startAnimationType = (fps):void => {
		this.fpsInterval = 1000 / fps;
		this.timeThen = Date.now();
		this.animateCarousel();
	}

	// Function to call recursively after 7 seconds
	animateCarousel: animateCarouselType = ():void => {
		this.frameId = requestAnimationFrame(this.animateCarousel.bind(this));
		this.timeNow = Date.now();
		this.timeElapsed = this.timeNow - this.timeThen;
		if (this.timeElapsed > this.fpsInterval && this.slider) {
			this.timeThen = this.timeNow - (this.timeElapsed % this.fpsInterval);
			this.slider.next();
		}
	}

	initializeLory: initializeLoryType = ():void => {
		if (!this.slider && this.dotCount > 1) {
			this.initLory(this.slideContainer);
		}
	}

	addSubscriptions: addSubscriptionsType = ():void => {
		this.subscribe('SITE.BREAKPOINT', this.initializeLory.bind(this));
	}
}
